<style scoped>

</style>
<template>
  <div>
    <Modal
      v-model="showModal"
      :closable="false"
      :mask-closable="false"
      :title="modalTitle"
    >
      <Form
        ref="form"
        :model="formData"
        :label-width="100"
      >
        <FormItem
          prop="name"
          label="名称"
          :rules="{ required: true, message: '名称必填', trigger: 'blur'}"
        >
          <Input
            v-model="formData.name"
            placeholder="请填写名称"
          />
        </FormItem>
        <FormItem
          prop="file_name"
          label="资质文件"
          :rules="{ required: display===1, message: '文件必须上传', trigger: 'blur'}"
        >
          <div>
            <Button
              v-show="!formData.file_name"
              size="small" 
              type="primary"
              style="display:inline"
              @click="prepareUploadFile"
            >
              上传文件
            </Button> 
            <p 
              v-show="formData.file_name"
              style="display:inline"
            >
              <span>{{ formData.file_name }}</span>
              <span style="margin-left:5px;cursor:pointer">
                <Icon
                  :size="20"
                  type="ios-close-circle-outline"
                  @click="delUploadFile"
                />
              </span>
            </p>
            <p 
              v-show=" display===2&&!formData.file_name"
              style="display:inline"
            >
              [ 如需修改资质文件请上传 ]
            </p>
            <div
              ref="contain" 
              style="display:none"
            />
          </div>
        </FormItem>
        <FormItem 
          prop="remark"
          label="备注"
        >
          <Input
            v-model="formData.remark"
            type="textarea"
            placeholder="请输入备注"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          @click="cancel"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="saveLoading"
          @click="ok"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    props: {
      display: {
        type: Number,
        default:() => 0
      },
      formProps: {
        type: Object,
        default:() => ({})
      },
      selectedSubject: {
        type: Object,
        default:() => ({})
      },
      saveLoading:{
        type: Boolean,
        default:() => false
      }
    },
    data() {
      this.el = null
      return {
        formData: {
          name:null,
          file_name: null,
          file:null,
          remark:null,
          id: null
        },
        modalTitle:'',
        showModal: false
      }
    },
    computed: {
      ...mapGetters({
        companies: 'async/companies',
      }),
      filter_companies() {
        if (!this.display) { return [] }
        const company_id_hash = this.list.reduce((total, item) => {
          total[item.company_id] = true
          return total
        }, {})
        if (this.formProps) {
          company_id_hash[this.formProps.company_id] = false
        }
        return this.companies.filter((item => !company_id_hash[item.id]))
      }
    },
    watch: {
      display(value) {
        if (value === 1) {
          this.modalTitle = '新增'
          Object.keys(this.formData).forEach(key => {
            this.formData[key] = null
          })
        }
        if (value === 2) {
          this.modalTitle = '编辑'
          this.formData.name = this.formProps.name
          this.formData.id = this.formProps.id
          this.formData.remark = this.formProps.remark
        }
        if (value === 0) {
          this.showModal = false
          this.$refs.form.resetFields() // 清理form表单
        } else {
          this.showModal = true
        }
      },
    },
    methods: {
      prepareUploadFile() {
        if (this.el) {
          this.el.click()
          return
        }
        this.el = document.createElement('input')
        this.el.setAttribute('type', 'file')
        this.$refs.contain.appendChild(this.el)
        this.el.click()
        this.el.addEventListener('change', this.uploadFile)
      },
      uploadFile() {
        const file = this.el.files[0]
        if (/pdf$/.test(file.type)) {
          this.formData.file_name = file.name
          this.formData.file = file
        } else {
          this.$Modal.error({
            title: '提示',
            content: '请上传pdf格式文件'
          })
        }
        this.el.removeEventListener('change', this.uploadFile)
        const childrenInputs = this.$refs.contain.childNodes
        for (let i = 0, len = childrenInputs.length; i < len; i++) {
          this.$refs.contain.removeChild(childrenInputs[i])
        }
        this.el = null
      },
      selectCompany(data) {
        const select_company = this.filter_companies.filter(item => item.id === data)[0] || {}
        this.formData.company_id = data
        this.formData.company_name = select_company.short_name
      },
      ok() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            //  eslint-disable-next-line
            const { file_name, id, ...other } = this.formData
            if (id !== null) {
              other.id = id
            }
            this.$emit('ok', {...other, subject_id: this.selectedSubject.id, call:() => {
              this.$Message.success({
                duration:0.7,
                content:this.formData.id === null ? '新增资质条目成功！' : '修改资质条目成功'
              })
              this.cancel()
            }}) 
          }
        })
      },
      cancel() {
        this.$emit('cancel')
      },
      dateChange(value) {
        this.formData.set_up_at = value
      },
      delUploadFile() {
        this.formData.file_name = null
        this.formData.file = null
      }
    }
  }
</script>
